import React from 'react';
import { Card, CardContent } from './ui/card';
import EditableText from './EditableText';
import RobotMascot from './RobotMascot';
import { RADIUS_SURFACE } from '../config/brand';

/** Gradient CTA card — purple → orange brand treatment + mascot pop-out. */
const CtaBanner = ({
  title,
  titleKey,
  subtitle,
  subtitleKey,
  children,
  footer,
  footerKey,
  className,
  showMascot = true,
}) => (
  <section className={`section-y px-4 overflow-visible ${className || ''}`}>
    <div className="mx-auto max-w-4xl overflow-visible pb-8 sm:pb-10">
      <Card className={`relative overflow-visible border-none bg-gradient-to-br from-[#3a00e0] via-[#5b21ff] to-[#fab03a] shadow-2xl shadow-[0_20px_50px_-20px_rgba(58,0,224,0.35)] ${RADIUS_SURFACE}`}>
        <CardContent className="relative overflow-visible p-8 text-center sm:p-12">
          <div
            className={`absolute inset-0 ${RADIUS_SURFACE} bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.14),transparent_50%)]`}
            aria-hidden="true"
          />
          {showMascot && (
            <RobotMascot
              variant="popout"
              size="xl"
              className="pointer-events-none h-24 w-24 translate-x-[10%] translate-y-[18%] sm:h-44 sm:w-44 sm:translate-x-[14%] sm:translate-y-[22%]"
            />
          )}
          <div className={`relative ${showMascot ? 'pr-14 sm:pr-24 md:pr-32' : ''}`}>
            {titleKey && typeof title === 'string' ? (
              <EditableText
                editKey={titleKey}
                defaultValue={title}
                as="h2"
                className="mb-3 text-[1.75rem] font-bold tracking-tight text-white sm:text-3xl lg:text-[2.35rem]"
              />
            ) : (
              <h2 className="mb-3 text-[1.75rem] font-bold tracking-tight text-white sm:text-3xl lg:text-[2.35rem]">
                {title}
              </h2>
            )}
            {subtitle &&
              (subtitleKey && typeof subtitle === 'string' ? (
                <EditableText
                  editKey={subtitleKey}
                  defaultValue={subtitle}
                  as="p"
                  multiline
                  className="mx-auto mb-8 max-w-2xl text-base leading-relaxed text-white/90 sm:text-lg"
                />
              ) : (
                <p className="mx-auto mb-8 max-w-2xl text-base leading-relaxed text-white/90 sm:text-lg">
                  {subtitle}
                </p>
              ))}
            {children}
            {footer &&
              (footerKey && typeof footer === 'string' ? (
                <EditableText
                  editKey={footerKey}
                  defaultValue={footer}
                  as="div"
                  multiline
                  className="text-white/80 text-sm mt-6"
                />
              ) : (
                <div className="text-white/80 text-sm mt-6">{footer}</div>
              ))}
          </div>
        </CardContent>
      </Card>
    </div>
  </section>
);

export default CtaBanner;
